import { authConstants } from '../constants';

export const authReducer = (state = {}, action) => {
    // delete password for security
    if(action && action.payload && action.payload.hasOwnProperty('password')) delete action.payload.password;

    switch(action.type) {
        case authConstants.ADMIN_LOGGED_IN: 
            return {
                ...state,
                loggedIn: true
            }

        case authConstants.ADMIN_LOGGED_OUT: 
            return {
                ...state,
                loggedIn: false
            }

        case authConstants.ADMIN_2FA_VERIFY: {
            return {
                ...state,
                TFA: true
            }
        }

        case authConstants.ADMIN_2FA_NOT_VERIFY: {
            return {
                ...state,
                TFA: false
            }
        }

        case authConstants.LOGOUT_SUCCESS:
            return {
                ...state,
                loggedIn: false,
                process: false
            }

        case authConstants.LOGOUT_REQUEST:
            return {
                ...state,
                process: true
            }

        case authConstants.AUTH_REQUEST:
        case authConstants.LOGIN_REQUEST:
            return {
                ...state,
                process: true
            }
        
        case authConstants.AUTH_SUCCESS:
        case authConstants.LOGIN_SUCCESS: 
            return {
                ...state,
                error: false,
                process: false,
                loggedIn: true
            }
        
        case authConstants.LOGOUT_FAILURE:
        case authConstants.AUTH_FAILURE:
        case authConstants.LOGIN_FAILURE: 
            return {
                ...state,
                error: true,
                process: false,
                loggedIn: false
            }
        
        case authConstants.AUTH_LOGIN_REDIRECT:
            return {
                ...state,
                redirect: Object.assign(state.redirect || {}, action.payload)
            }
        
        default:
            return state;
    }
}

export default authReducer;


// WEBPACK FOOTER //
// ./src/reducers/auth.js